import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentTicketDiagonalFilled = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  (
    { fillColor = '#212121', ...props }: { fillColor?: string } & SvgProps,
    ref
  ) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      ref={ref}
      {...props}
    >
      <Path
        d='M15.59 2.53a2.25 2.25 0 00-3.181 0L2.53 12.41a2.25 2.25 0 000 3.182l1.172 1.171c.51.511 1.227.42 1.66.162a1.25 1.25 0 011.713 1.713c-.257.433-.349 1.15.162 1.66L8.41 21.47a2.25 2.25 0 003.182 0l9.878-9.878a2.25 2.25 0 000-3.182l-1.171-1.172c-.51-.51-1.228-.42-1.661-.162a1.25 1.25 0 01-1.713-1.713c.258-.433.349-1.15-.162-1.66L15.591 2.53z'
        fill={fillColor}
      />
    </Svg>
  )
)

export default FluentTicketDiagonalFilled
